import { createApi } from "@reduxjs/toolkit/dist/query/react"
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { currentUrl } from "../../url"

export const newBookingApi = createApi({
  reducerPath: 'newBookingApi',
  tagTypes: ['newBooking'],
  baseQuery: fetchBaseQuery({
    baseUrl: currentUrl,
    prepareHeaders: (headers) => {
      // Читаем токен при каждом запросе, чтобы использовать актуальное значение
      const accessToken = localStorage.getItem('accessToken')
      if (accessToken) {
        // Убеждаемся, что токен имеет правильный формат (Bearer префикс)
        const token = accessToken.startsWith("Bearer ")
          ? accessToken
          : `Bearer ${accessToken}`
        headers.set('Authorization', token)
        headers.set('Accept', 'application/json')
        // headers.set('Content-type', 'x-www-form-urlencoded')
      }
      return headers
    }
  }),
  endpoints: build => ({
    getBookings: build.query({
      query: (params) => {
        const queryParams = new URLSearchParams({
          keyword: params.search || '',
          start_date_from: params.startDate || '',
          start_date_to: params.endDate || '',
          page: String(params.page || 1),
          perPage: String(params.perPage || 10),
          limit: String(params.limit || 10),
        })
        if (params.master_id) queryParams.append("master_id", String(params.master_id))
        if (params.status_id) queryParams.append("status_id", String(params.status_id))
        return `/master/search/bookings?${queryParams.toString()}`
      },
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data.map(({ id }) => ({ type: 'newBooking', id })),
            { type: 'newBooking', id: 'LIST' },
          ]
          : [{ type: 'newBooking', id: 'LIST' }],
    }),
    getOneBooking: build.query({
      query: (id) => `/master/bookings/${id}`,
      providesTags: (result, error, id) => [{ type: 'newBooking', id }]
    }),
    createBooking: build.mutation({
      query: (body) => ({
        url: `/master/bookings`,
        method: 'POST',
        body
      }),
      invalidatesTags: [{ type: 'newBooking', id: 'LIST' }]
    }),
    editBooking: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/master/bookings/${id}`,
        method: 'PATCH',
        body
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'newBooking', id: 'LIST' },
        { type: 'newBooking', id }
      ]
    }),
    editServices: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/master/bookings/${id}`,
        method: 'PATCH',
        body
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'newBooking', id: 'LIST' },
        { type: 'newBooking', id }
      ],
    }),
    deleteBooking: build.mutation({
      query: (id) => ({
        url: `/master/bookings/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'newBooking', id: 'LIST' },
        { type: 'newBooking', id }
      ]
    }),
    cancelBooking: build.mutation({
      query: (id) => ({
        url: `/master/bookings/${id}`,
        method: 'PATCH',
        body: { status_id: 3 },
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'newBooking', id: 'LIST' },
        { type: 'newBooking', id }
      ]
    }),
    deleteServices: build.mutation({
      query: ({ booking_id, service_id }) => ({
        url: `/master/booking-delete-service`,
        method: 'DELETE',
        body: {
          booking_id,
          service_id
        }
      }),
      invalidatesTags: (result, error, { booking_id }) => [
        { type: 'newBooking', id: 'LIST' },
        { type: 'newBooking', id: booking_id }
      ]
    }),

  })
})

export const { useGetBookingsQuery, useCreateBookingMutation, useEditServicesMutation, useEditBookingMutation, useDeleteBookingMutation, useGetOneBookingQuery, useDeleteServicesMutation } = newBookingApi;
